import type {BaseComponentConfig} from "@gamzix/slot_core";

class GamePreloaderComponent extends PreloaderComponent {

    constructor(config: BaseComponentConfig) {
        super(config);

        const params = new URLSearchParams(new URL(window.location.href).search);
        const provider = params.get('provider');

        this.status_checkers = {
            ...super.getStatusCheckers(),

            isNotGamzix: () => provider ? params.get('provider') === "gamzix" : true
        };
    }
}

// @ts-ignore
Game.src.component.PreloaderComponent = GamePreloaderComponent;
